import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import React, { useEffect, useRef, useState } from "react";
import { changeLang } from "../../componets/Language/ChangeLang";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { Toast } from "primereact/toast";
import ScreenLoader from "../../componets/ScreenLoader";
import { DermacationLevels } from "../../constants";

const MoveDelimitations = ({
	moveDermacation,
	isLoading,
	setmoveDermacation,
	dermacationForm,
	isNational,
	nodeName,
	setdermacationForm,
	onMove = () => {}
}) => {
	const [delimitation, setDelimitation] = useState(null);
	const toast = useRef(null);
	useEffect(() => {
		//If demarcation level from the demarcation filtering is 4[Registration centre] and the demarcation being moved is 5[village]
		if (delimitation?.delimitationLevelID == 4 && dermacationForm.DelimitationLevelID == 5) {
			setdermacationForm((prev) => ({
				...prev,
				registrationCenterNAID: isNational ? delimitation.delimitationID : prev.registrationCenterNAID,
				registrationCenterLGID: !isNational ? delimitation.delimitationID : prev.registrationCenterLGID
			}));
		}
		//If demarcation level from the demarcation filtering is 3[Polling/Elector division] and the demarcation being moved is 4[Registration centre]
		else if (delimitation?.delimitationLevelID == 3 && dermacationForm.DelimitationLevelID == 4) {
			setdermacationForm((prev) => ({
				...prev,
				DelimitationParentID: delimitation.delimitationID
			}));
		}
	}, [
		delimitation,
		isNational,
		dermacationForm?.DelimitationParentID,
		dermacationForm?.registrationCenterNAID,
		dermacationForm?.registrationCenterLGID
	]);
	return (
		<Dialog
			header={
				dermacationForm?.DelimitationLevelID === DermacationLevels?.Level4
					? `Move ${isNational ? "Voting Centre " : "Polling Centre"}`
					: "Move Village"
			}
			style={{ width: "80vw", height: "95vh" }}
			onHide={() => setmoveDermacation(false)}
			draggable={false}
			footer={
				<div className="flex justify-content-end gap-2">
					<Button label="Cancel" icon="pi pi-times" text onClick={() => setmoveDermacation(false)} />
					<Button
						label="Move"
						icon="pi pi-check"
						disabled={
							(dermacationForm.DelimitationLevelID == DermacationLevels.Level4 && !dermacationForm.DelimitationParentID) ||
							(dermacationForm.DelimitationLevelID == DermacationLevels.Level5 &&
								((isNational && !dermacationForm.registrationCenterNAID) || (!isNational && !dermacationForm.registrationCenterLGID)))
						}
						onClick={onMove}
					/>
				</div>
			}
			className="py-4"
			visible={moveDermacation}
		>
			<ScreenLoader visible={isLoading} />
			<Toast ref={toast} />

			<div>
				Move{" "}
				{dermacationForm?.DelimitationLevelID === DermacationLevels?.Level4
					? dermacationForm?.registrationCentreName
					: dermacationForm?.villageName}
				<Divider align="center">
					<h6>
						{dermacationForm?.DelimitationLevelID === DermacationLevels?.Level4
							? `Move from ${changeLang.get(isNational ? "national_delimitation.level3PollingElectorDivision" : "local_delimitation.level3PollingElectorDivision")}`
							: `Move from ${changeLang.get(isNational ? "national_delimitation.level4RegistrationCentre" : "local_delimitation.level4RegistrationCentre")}`}
					</h6>
				</Divider>
				<div className="p-fluid p-grid  section-style-block">
					<div className="p-field p-col-6 p-md-4">
						<label>
							{isNational
								? changeLang.get("national_delimitation.level1District")
								: changeLang.get("local_delimitation.level1District")}
						</label>
						<div className=" p-inputtext p-component p-filled p-disabled">{dermacationForm?.districtName}</div>
					</div>
					<div className="p-field p-col-6 p-md-4">
						<label>
							{isNational
								? changeLang.get("national_delimitation.level2ConstituencyCouncil")
								: changeLang.get("local_delimitation.level2ConstituencyCouncil")}
						</label>
						<div className=" p-inputtext p-component p-filled p-disabled">{dermacationForm?.constituencyName}</div>
					</div>
					<div className="p-field p-col-6 p-md-4">
						<label>
							{isNational
								? changeLang.get("national_delimitation.level3PollingElectorDivision")
								: changeLang.get("local_delimitation.level3PollingElectorDivision")}
						</label>
						<div className=" p-inputtext p-component p-filled p-disabled">{dermacationForm?.votingDistrictName}</div>
					</div>
					{dermacationForm?.DelimitationLevelID > DermacationLevels?.Level4 && (
						<div className="p-field p-col-6 p-md-4">
							<label>{changeLang.get("national_delimitation.level4RegistrationCentre")}</label>
							<div className=" p-inputtext p-component p-filled  p-disabled">{dermacationForm?.registrationCentreName}</div>
						</div>
					)}
				</div>
				<Divider align="center">
					<h6>
						{dermacationForm?.DelimitationLevelID === DermacationLevels?.Level4
							? `Move to ${changeLang.get(isNational ? "national_delimitation.level3PollingElectorDivision" : "local_delimitation.level3PollingElectorDivision")}`
							: `Move to ${changeLang.get(isNational ? "national_delimitation.level4RegistrationCentre" : "local_delimitation.level4RegistrationCentre")}`}
					</h6>
				</Divider>
				<LocalDelimitationNational
					showVillage={false}
					isMovedermacationManagement={true}
					dermacationForm={dermacationForm}
					showRegistrationCentre={dermacationForm?.DelimitationLevelID > DermacationLevels?.Level4}
					setLocalDelimitation={setDelimitation}
					isNational={isNational}
					onChange={(delimitationID, delimitationLevelID, _loaded, selectedName) => {
						setDelimitation({
							delimitationID,
							delimitationLevelID,
							selectedName
						});
					}}
				/>
			</div>
		</Dialog>
	);
};

export default MoveDelimitations;
